import { LineUpActionTypes } from '../types/actions/lineUp';

export const closeLineUpNotificationsPopUp = () => ({
  type: LineUpActionTypes.CLOSE_NOTIFICATIONS_INFOS_POP_UP,
});

export const progressivelyOpenLineUpView = (matchId: number) => ({
  type: LineUpActionTypes.PROGRESSIVELY_OPEN_VIEW,
  payload: {
    matchId,
  },
});
